/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1PrintedcoverpapersQueryResponse } from '../../types/GetV1Printedcoverpapers.ts'

export const getV1PrintedcoverpapersQueryKey = () => [{ url: '/v1/PrintedCoverPapers' }] as const

export type GetV1PrintedcoverpapersQueryKey = ReturnType<typeof getV1PrintedcoverpapersQueryKey>

/**
 * {@link /v1/PrintedCoverPapers}
 */
export async function getV1Printedcoverpapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1PrintedcoverpapersQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/PrintedCoverPapers`, ...requestConfig })
    return res
}

export function getV1PrintedcoverpapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1PrintedcoverpapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1PrintedcoverpapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1PrintedcoverpapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Printedcoverpapers(config)
        },
    })
}

/**
 * {@link /v1/PrintedCoverPapers}
 */
export function useGetV1Printedcoverpapers<
    TData = ResponseConfig<GetV1PrintedcoverpapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1PrintedcoverpapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1PrintedcoverpapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1PrintedcoverpapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1PrintedcoverpapersQueryKey()

    const query = useQuery(
        {
            ...getV1PrintedcoverpapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
